import React from "react";

function SoundWave() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.333"
      height="24"
      viewBox="0 0 25.333 24"
    >
      <path
        id="Path_18485"
        data-name="Path 18485"
        d="M26.333,3V21.667a5.331,5.331,0,1,1-2.667-4.62V5.667h-12v16A5.331,5.331,0,1,1,9,17.047V3Zm-20,21.333a2.667,2.667,0,1,0-2.667-2.667A2.667,2.667,0,0,0,6.333,24.333Zm14.667,0a2.667,2.667,0,1,0-2.667-2.667A2.667,2.667,0,0,0,21,24.333Z"
        transform="translate(-1 -3)"
        fill="#fff"
      />
    </svg>
  );
}

export default SoundWave;
